export enum ScreenStates {
  INITIAL,
  PREVIEW_CHECKED,
  PREVIEW_ACCEPTED,
}
